import axios from "axios";

import { MAX_ELEMENTS_PER_PAGE } from "../constants/constants.ts";

export function useSenderService() {
  async function removeSender(email: string): Promise<void> {
    await axios.delete(`${Config.apiBaseUrl}/senders/${email}`);
  }
  const senderApiUrl = Config.apiBaseUrl + "/senders";
  async function updateSendingMode(id: number) {
    await axios.patch(`${senderApiUrl}/${id}`);
  }

  async function fetchSenders(page: number, statuses: string[]) {
    const response = await axios.get(
      `${senderApiUrl}?page=${page}&size=${MAX_ELEMENTS_PER_PAGE}&direction=DESC&sortBy=lastUsed&statuses=${statuses}`
    );
    return response.data;
  }

  async function refreshSenders() {
    await axios.get(`${senderApiUrl}/refresh`);
  }

  async function createSender(email: string) {
    await axios.post(`${senderApiUrl}`, { email: email });
  }

  return {
    removeSender,
    updateSendingMode,
    fetchSenders,
    createSender,
    refreshSenders
  };
}
